import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import authStore from "../../store/authStore";
import MyLoader from "../myLoader/MyLoader";

const RequireAuth = (props) => {
  const store = authStore();
  useEffect(() => {
    if (store.isLogged === null) {
      store.checkAuth();
    }
  }, []);

  if (store.isLogged === null) {
    return <MyLoader height="50vh" />;
  }

  if (store.isLogged === false) {
    return <Navigate to="/" />;
  }

  return <div>{props.children}</div>;
};

export default RequireAuth;
